/**
 * A listing's size chart as a table (MERCH-88). Pure. `chart`: { name, note, columns: [label…],
 * rows: [[cell…]…] } from the storefront row (lib/catalog/sizeCharts). Null when there is none to show.
 */
export function chartTable(chart) {
  if (!chart || !Array.isArray(chart.columns) || !chart.columns.length || !Array.isArray(chart.rows) || !chart.rows.length) return null;
  const columns = chart.columns.map((label, j) => ({ key: `c${j}`, label }));
  const data = chart.rows.map((r, i) => ({ id: i, ...Object.fromEntries(chart.columns.map((_, j) => [`c${j}`, r[j] == null || r[j] === '' ? '—' : r[j]])) }));
  return { title: chart.name || 'Size chart', note: chart.note || null, columns, data };
}
